import Model from './utils/model'
import nexus from '@db2b/nexus-js'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Propale'
    },
    name: 'proposal',
    url: nexus.url('callcenter', 'proposals')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/proposal.js